require('./hireCardDiamondPackView.scss');

// @vendors
const PropTypes = require('prop-types');
const React = require('react');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');

// @helpers
const { formatText, getFinalTitle } = require('core/i18n').i18n;
const { ownerFromAccount } = require('utilities/contactCenter/cardHireHelper');
const { getCollectiveTagDetails } = require('utilities/collectivesHelper');
const { isAvailableHireCreditCards } = require('utilities/cardsHelper');

// @actions
const hireCardDiamondPackActions = require('actions/hireCardDiamondPack');
const hireCreditLimitActions = require('actions/hireCreditLimit');
const preContractualMailActions = require('actions/contactCenter/preContractualMailInfo/preContractualMailInfo');
const shippingAddressAction = require('actions/shippingAddress');
const mergePreContractualsPDF = require('actions/mergePreContractualsPDF');
const blockedAccountsAction = require('actions/blockedAccounts');
const precontractualDocumentMailAction = require('actions/precontractualDocumentsMailer');
const termsAndCondsInfoActions = require('actions/termsAndCondsInfo');
const hireCardCreditINEActions = require('actions/commons/hireCardCreditINE');
const printedActions = require("actions/contactCenter/printer");
const mortgageRequestHolderConfirmation = require("actions/mortgageRequest/mortgageRequestHolderConfirmation");


// @commons
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');

// @components
const HireCardDiamondPackStep1 = require('components/hire/cardDiamondPack/hireCardDiamondPackStep1/hireCardDiamondPackStep1');
const HireCardDiamondPackStep2 = require('components/hire/cardDiamondPack/hireCardDiamondPackStep2/hireCardDiamondPackStep2');
const HireCardDiamondPackStep3 = require('components/hire/cardDiamondPack/hireCardDiamondPackStep3/hireCardDiamondPackStep3');
const HireCardDiamondPackStep4 = require('components/hire/cardDiamondPack/hireCardDiamondPackStep4/hireCardDiamondPackStep4');
const HireCardDiamondPackStep5 = require('components/hire/cardDiamondPack/hireCardDiamondPackStep5/hireCardDiamondPackStep5');
const HireCardDiamondPackSuccess = require('components/hire/cardDiamondPack/hireCardDiamondPackSuccess/hireCardDiamondPackSuccess');
const HireCarDiamondPackError = require('components/hire/cardDiamondPack/hireCardDiamondPackError/hireCardDiamondPackError');
const HireCardOpenCreditStepINE = require('components/hire/cardINEDocument/hireCardOpenCreditStepINE');
const HireCardSidebar = require('components/hire/hireCardSidebar/hireCardSidebar');
const WebappRender = require('components/conditionalRender/webappRender');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender');
const { CallMeBack } = require('components/callMeBack/callMeBack');
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');

// @constants
const {
    ACCOUNT_INTERVENTION_CO_OWNER,
    ACCOUNT_INTERVENTION_OWNER,
    ACCOUNT_INTERVENTION_REPRESENTATIVE,
    CHECKING_ACCOUNT_CODE,
    CREDIT_CARD_TYPE_PACK,
    CREDIT_CARD_SUBTYPE_DIAMOND,
    DEBIT_CARD_TYPE,
    DEBIT_CARD_SUBTYPE_DIAMOND,
    DIAMOND_PACK_HIRING,
    DIAMOND_PACK_STANDARD,
    EURO_TEXT,
    REDIRECT_URL,
    THIRD_STEP,
    WIZARD_FIRST_STEP,
    WIZARD_SECOND_STEP
} = require('constants/index');
const { DIAMOND_PACK_PRODUCT_ALIAS } = require('constants/hiringProductInformation');
const { HIRE_CARD_DIAMOND_PACK } = require('constants/operationCodesAccounts');
const {
    WEB_INACTIVE_ACCOUNT_ENABLED,
    CREDIT_CARD_REVOLVING_PROCESS,
    LIMIT_CREDIT_CARD,
    ES_COUNTRY,
    MESSAGE_HIRE_24H,
    NOT_ALLOWED_NEW_CREDIT_CARDS_FLOW_COUNTRIES
} = require('constants/flagBasedFeatures');
const EXTRA_IMAGE = 'B.506.008.003';
const {
    ACCOUNTS_WITH_CHEQUES_OR_DEBITS_SUBTYPES
} = require('constants/accounts');
const { catalogue, analyticsId } = require('../../components/hire/cardDiamondPack/analytics/hireCardDiamonPackAnalytics');

class HireCardDiamondPackView extends React.Component {
    constructor(props) {
        super(props);
        this.isReady = this.isReady.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }

    componentDidMount() {
        const {
            getBlockedAccounts,
            getshippingAddressList,
            immAccounts,
            match: { params: { redirect } },
            resetPrecontractualDocumentMail,
            validateStep,
            immFlagBasedFeatures,
            reset,
            resetBlockedAccounts,
            resetPrecontractualMail,
            resetTermsAndCondsText,
        } = this.props;
        const newCardsFF = immFlagBasedFeatures.get(NOT_ALLOWED_NEW_CREDIT_CARDS_FLOW_COUNTRIES);
        if (newCardsFF) {
            reset();
            resetBlockedAccounts();
            resetTermsAndCondsText();
            if (__CONTACT_CENTER__) resetPrecontractualMail()

        }

        resetPrecontractualDocumentMail();
        if (redirect === REDIRECT_URL) {
            validateStep(WIZARD_FIRST_STEP);
        }
        getshippingAddressList();

        if (!immAccounts.get('blockedAccountsSuccess')) {
            const accountsIndexes = this.filterAccounts();
            const accounts = accountsIndexes.map(id => immAccounts.getIn(['byId', id]));
            getBlockedAccounts(accounts, HIRE_CARD_DIAMOND_PACK);
        }
    }

    componentWillUnmount() {
        const {
            reset,
            resetBlockedAccounts,
            resetPrecontractualMail,
            resetTermsAndCondsText,
        } = this.props
        reset();
        resetBlockedAccounts();
        resetTermsAndCondsText();
        if (__CONTACT_CENTER__) resetPrecontractualMail();
    }

    getProcessDetail() {
        return `${CREDIT_CARD_TYPE_PACK}.${CREDIT_CARD_SUBTYPE_DIAMOND} - ${DEBIT_CARD_TYPE}.${DEBIT_CARD_SUBTYPE_DIAMOND}`;
    }

    handleCancel() {
        this.props.history.push('/myprofile/cards');
    }


    buildINE() {
        const { immHireCardDiamondPack, cardsConfimationScrollDown, checkCheckedDocument, printedAndSignedRadioChanged, enableButtonOffice, checkRadioButton, immPrinter, hireCardDiamondPackPrintDocument } = this.props;
        const documentINE = immHireCardDiamondPack.get('documentINE')
        const scrollDown = immHireCardDiamondPack.get('scrollDown')
        const agreeIneCheckbox = immHireCardDiamondPack.get('agreeIneCheckbox')
        const checkButtonRadio = immHireCardDiamondPack.get('checkButtonRadio')
        const printDocument = immHireCardDiamondPack.get('printDocument')
        const documentsPrintedAndSigned = immHireCardDiamondPack.get('cardsDocumentsPrintedAndSigned')

        return (
            <HireCardOpenCreditStepINE
                documentINE={documentINE}
                cardsConfimationScrollDown={cardsConfimationScrollDown}
                scrollDown={scrollDown}
                checkCheckedDocument={checkCheckedDocument}
                agreeIneCheckbox={agreeIneCheckbox}
                printedAndSignedRadioChanged={printedAndSignedRadioChanged}
                enableButtonOffice={enableButtonOffice}
                checkRadioButton={checkRadioButton}
                checkButtonRadio={checkButtonRadio}
                hireCardOpenCreditprintDocument={hireCardDiamondPackPrintDocument}
                printDocument={printDocument}
                immPrinter={immPrinter}
                documentsPrintedAndSigned={documentsPrintedAndSigned}
            />
        );
    }

    isReady() { // it warns the user if he's about to lose changes
        const { immHireCardDiamondPack } = this.props;
        let showPreLeaveModal = true;

        if (immHireCardDiamondPack.get('visibleStep') === 1) {
            showPreLeaveModal = false;
        }

        return showPreLeaveModal;
    }

    buildSuccessful() {
        const {
            immAccounts,
            immCollectivesCardContent,
            immHireCardImageSelector,
            immHireCardNameSelector,
            immHireCardDiamondPack,
            immHireCreditLimit,
            immHirePaymentMethod,
            immProfile,
            immShippingAddressList
        } = this.props;
        const selectedAccount = immHireCardDiamondPack.getIn(['steps', THIRD_STEP, 'accountId']);
        const immAccount = immAccounts.getIn(['byId', selectedAccount]);

        const processDetail = this.getProcessDetail();

        return (
            <div className="col-xs-12 col-md-offset-1 col-md-10">
                <HireCardDiamondPackSuccess
                    extraImage={EXTRA_IMAGE}
                    immAccount={immAccount}
                    immCollectivesCardContent={immCollectivesCardContent}
                    immHireCardDiamondPack={immHireCardDiamondPack}
                    immHireCardImageSelector={immHireCardImageSelector}
                    immHireCardNameSelector={immHireCardNameSelector}
                    immHireCreditLimit={immHireCreditLimit}
                    immHirePaymentMethod={immHirePaymentMethod}
                    immProfile={immProfile}
                    immShippingAddress={immShippingAddressList.get('shippingAddress')}
                    processDetail={processDetail}
                />
            </div>
        );
    }

    filterAccounts() {
        const { immAccounts } = this.props;
        const interventionTypes = [
            ACCOUNT_INTERVENTION_OWNER,
            ACCOUNT_INTERVENTION_CO_OWNER,
            ACCOUNT_INTERVENTION_REPRESENTATIVE
        ];
        const accountsIndexes = immAccounts.get('byOrder').filter(accountId =>
            // We remove the accounts that are not in euros
            immAccounts.getIn(['byId', accountId, 'balance', 'currency']) === EURO_TEXT
        ).filter(accountId =>
            // We remove the accounts that don't comply with the requisites of product type and subtype
            immAccounts.getIn(['byId', accountId, 'newProduct']) === String(CHECKING_ACCOUNT_CODE) &&
            ACCOUNTS_WITH_CHEQUES_OR_DEBITS_SUBTYPES.includes(immAccounts.getIn(['byId', accountId, 'accountType']))
        ).filter(accountId =>
            // We remove the accounts where the user is not the owner
            interventionTypes.includes(immAccounts.getIn(['byId', accountId, 'interventionType']))
        );

        // We return a list with the ids of the filtered accounts
        return accountsIndexes;
    }

    buildWizardHiringSteps() {
        const {
            gestorCrossEnabled,
            handleAccountChange,
            handleAgreementCheckboxChange,
            hireCardDiamondPack,
            immAccounts,
            immCollectivesCardContent,
            immFlagBasedFeatures,
            immGlobalVariables,
            immHireCardImageSelector,
            immHireCardDiamondPack,
            immHireCardNameSelector,
            immHireCreditLimit,
            immHireContactData,
            immHireInformation,
            immHirePaymentMethod,
            immHiringProductBanners,
            immPdfData,
            immProfile,
            immShippingAddressList,
            immTopbar,
            isCollectiveEnabled,
            requestPDFMerge,
            sendPrecontractualDocumentMail,
            setShippingAddress,
            setAllAccountsToInactive,
            setHireCreditLimit,
            setTermsAndCondsText,
            setVisibleStep,
            setWillCancel,
            toggleCreditLimitModal,
            validateStep,
            validate,
            immRevolvingPersistentData,
            onHandleChangeCheckBoxCC,
            myCardsTarjetasHire,
            cardsConfimationScrollDownPolicy,
            hireCardDiamondPackPrintDocument,
            hireCardDiamondPackPrintDocumentPolicy,
            printedAndSignedRadioChanged,
            enableButtonOffice,
            checkRadioButtonPolicy,
            getInitCardsDocuments,
            processEmail
        } = this.props;
        const newCardsFF = immFlagBasedFeatures.get(NOT_ALLOWED_NEW_CREDIT_CARDS_FLOW_COUNTRIES);
        const documentsPrintedAndSigned = immHireCardDiamondPack.get('cardsDocumentsPrintedAndSigned');

        const wizardActions = {
            cancel: this.handleCancel,
            finish: newCardsFF ? myCardsTarjetasHire : () => hireCardDiamondPack(hireCmsKey),
            setVisibleStep,
            setWillCancel,
            validateStep
        };

        let immSteps = newCardsFF && (!__CONTACT_CENTER__ || isPrintOfficeMode()) ? immHireCardDiamondPack.get('newSteps') : immHireCardDiamondPack.get('steps');
        const visibleStep = immHireCardDiamondPack.get('visibleStep')
        immSteps = immSteps.map((step, index) => {
            if (index < visibleStep) {
                return step.set('valid', true);
            }
            return step;
        });

        const sendMailParams = {
            type: CREDIT_CARD_TYPE_PACK,
            subType: CREDIT_CARD_SUBTYPE_DIAMOND,
            standar: DIAMOND_PACK_STANDARD
        };

        const immShippingAddress = immShippingAddressList.get('shippingAddress');
        let hasShippingAddress = true;
        const hireCmsKey = __CONTACT_CENTER__ ? 'Contrataciones_Paso_default_diamondpack_cc_1' : 'Contrataciones_Paso_default_diamondpack_1';
        const showPreLeaveModal = this.isReady();

        const nextButtonDisabledStep2 = immHireCardImageSelector.get('isFetching') || immHireCardNameSelector.get('isFetching');
        let isCollectiveEnabledForDiamondPack = !!immCollectivesCardContent.get(DIAMOND_PACK_HIRING);
        if (gestorCrossEnabled) {
            const immProductBanners = immHiringProductBanners.get('productBanners') || [];
            const diamondPackWafer = immProductBanners.find((banner) => {
                return banner.get('alias') === DIAMOND_PACK_PRODUCT_ALIAS
            });
            isCollectiveEnabledForDiamondPack = diamondPackWafer && diamondPackWafer.get('isCollectiveProduct') && isCollectiveEnabled;
        }
        let collectiveTagData = getCollectiveTagDetails(immTopbar, immProfile);
        const accountsIndexes = this.filterAccounts().toJS();
        const showIneAndRevolving = immFlagBasedFeatures.get(CREDIT_CARD_REVOLVING_PROCESS);

        const isShippingAddressButtonDisabled = !!immShippingAddressList && !immShippingAddressList.get('shippingAddressType') && immFlagBasedFeatures.get(ES_COUNTRY);
        const loadingFlag = immHireCardDiamondPack.get('loadingFlag');
        const agreeIneCheckbox = immHireCardDiamondPack.get('agreeIneCheckbox')
        const checkButtonRadio = immHireCardDiamondPack.get('checkButtonRadio')

        const productName = this.getProcessDetail();
        const tealiumData = [
            catalogue[analyticsId.DIAMOND_PACK_CARD_STEP_1_VIEW]({ productName }),
            catalogue[analyticsId.DIAMOND_PACK_CARD_STEP_2_VIEW]({ productName }),
            catalogue[analyticsId.DIAMOND_PACK_CARD_STEP_3_VIEW]({ productName }),
            catalogue[analyticsId.DIAMOND_PACK_CARD_STEP_4_VIEW]({ productName }),
            catalogue[analyticsId.DIAMOND_PACK_CARD_STEP_5_VIEW]({ productName }),
        ];

        const checkboxChecked = immHireCardDiamondPack.get('agreeIneCheckbox')
        const newFinalButtonDisabledCC = newCardsFF && checkboxChecked;

        const commonSteps = [
            <WizardStep
                cancelButton={true}
                position="first"
                isLoading={loadingFlag}
            >
                <WebappRender>
                    <HireCardDiamondPackStep1
                        contractName="diamond-pack"
                        flagBasedFeatures={immFlagBasedFeatures}
                        gestorCrossEnabled={gestorCrossEnabled}
                        handleAgreementCheckboxChange={handleAgreementCheckboxChange}
                        hireCmsKey={hireCmsKey}
                        immHireCardDiamondPack={immHireCardDiamondPack}
                        immHireInformation={immHireInformation}
                        immProfileFields={immProfile}
                        requestPDFMerge={requestPDFMerge}
                        sendMailParams={sendMailParams}
                        setTermsAndCondsText={setTermsAndCondsText}
                        showIneAndRevolving={showIneAndRevolving}
                    />
                </WebappRender>
                <ContactCenterRender>
                    <HireCardDiamondPackStep1
                        contractName="diamond-pack"
                        flagBasedFeatures={immFlagBasedFeatures}
                        gestorCrossEnabled={gestorCrossEnabled}
                        handleAgreementCheckboxChange={handleAgreementCheckboxChange}
                        hireCmsKey={hireCmsKey}
                        immHireCardDiamondPack={immHireCardDiamondPack}
                        immHireInformation={immHireInformation}
                        immProfileFields={immProfile}
                        requestPDFMerge={requestPDFMerge}
                        sendMailParams={sendMailParams}
                        setTermsAndCondsText={setTermsAndCondsText}
                        showIneAndRevolving={showIneAndRevolving}
                    />
                </ContactCenterRender>
            </WizardStep>,
            <WizardStep
                cancelButton={true}
                nextButtonDisabled={nextButtonDisabledStep2}
                onBackClick={false}
                position="middle"
            >
                <HireCardDiamondPackStep2
                    extraImage={EXTRA_IMAGE}
                    immFlagBasedFeatures={immFlagBasedFeatures}
                    immHireCardImageSelector={immHireCardImageSelector}
                    immHireCardNameSelector={immHireCardNameSelector}
                />
            </WizardStep>,
            <WizardStep
                cancelButton={true}
                nextButtonDisabled={immHireCreditLimit.get('isFetching') || immRevolvingPersistentData.get('isIframeError')}
                onBackClick={false}
                position="middle"
            >
                <HireCardDiamondPackStep3
                    accountsIndexes={accountsIndexes}
                    handleAccountChange={handleAccountChange}
                    immAccounts={immAccounts}
                    immFlagBasedFeatures={immFlagBasedFeatures}
                    immGlobalVariables={immGlobalVariables}
                    immHireCardDiamondPack={immHireCardDiamondPack}
                    immHireCardImageSelector={immHireCardImageSelector}
                    immHireCreditLimit={immHireCreditLimit}
                    immHirePaymentMethod={immHirePaymentMethod}
                    isInactiveAccountsEnabled={immFlagBasedFeatures.get(WEB_INACTIVE_ACCOUNT_ENABLED)}
                    setAllAccountsToInactive={setAllAccountsToInactive}
                    setHireCreditLimit={setHireCreditLimit}
                    toggleCreditLimitModal={toggleCreditLimitModal}
                    validate={validate}
                />
            </WizardStep>,
            <WizardStep
                cancelButton={true}
                onBackClick={false}
                position="middle"
                nextButtonDisabled={isShippingAddressButtonDisabled}
            >
                <HireCardDiamondPackStep4
                    immHireContactData={immHireContactData}
                    immShippingAddressList={immShippingAddressList}
                    setShippingAddress={setShippingAddress}
                    immFlagBasedFeatures={immFlagBasedFeatures}
                    getInitCardsDocuments={getInitCardsDocuments}
                    newCardsFF={newCardsFF}
                />
            </WizardStep>,
            <WizardStep
                addLoadingBehaviour
                cancelButton={true}
                immFinalButton={'hireCardDiamondPack-hire'}
                isLoading={immHireCardDiamondPack.get('isFetching')}
                onBackClick={false}
                position="last"
                officeSignature={newCardsFF && isPrintOfficeMode()}
                finalButtonDisabled={newCardsFF ? (newFinalButtonDisabledCC ? false : true) : null}
            >
                <HireCardDiamondPackStep5
                    contractName="diamond-pack"
                    immFlagBasedFeatures={immFlagBasedFeatures}
                    immHireCardDiamondPack={immHireCardDiamondPack}
                    immHireCardImageSelector={immHireCardImageSelector}
                    immHireCardNameSelector={immHireCardNameSelector}
                    immHireCreditLimit={immHireCreditLimit}
                    immHirePaymentMethod={immHirePaymentMethod}
                    immPdfData={immPdfData}
                    immShippingAddress={immShippingAddressList.get('shippingAddress')}
                    handleAgreementCheckboxChange={handleAgreementCheckboxChange}
                    operativeName={__CONTACT_CENTER__ ? "operatives-cardHire_visaOpenNew" : undefined}
                    sendMailParams={sendMailParams}
                    sendPrecontractualDocumentMail={sendPrecontractualDocumentMail}
                    setTermsAndCondsText={setTermsAndCondsText}
                    showIneAndRevolving={showIneAndRevolving}
                    onHandleChangeCheckBoxCC={onHandleChangeCheckBoxCC}
                    hireCardDiamondPackPrintDocument={hireCardDiamondPackPrintDocument}
                    cardsConfimationScrollDownPolicy={cardsConfimationScrollDownPolicy}
                    hireCardDiamondPackPrintDocumentPolicy={hireCardDiamondPackPrintDocumentPolicy}
                    printedAndSignedRadioChanged={printedAndSignedRadioChanged}
                    enableButtonOffice={enableButtonOffice}
                    checkRadioButtonPolicy={checkRadioButtonPolicy}
                    documentsPrintedAndSigned={documentsPrintedAndSigned}
                    processEmail={processEmail}
                />
            </WizardStep>
        ];
        const newSteps = newCardsFF && (__CONTACT_CENTER__ && isPrintOfficeMode() || !__CONTACT_CENTER__) ? [
            ...commonSteps.slice(0, 4),
            <WizardStep
                cancelButton={true}
                immFlagBasedFeatures={immFlagBasedFeatures}
                onBackClick={false}
                position="middle"
                nextButtonDisabled={isPrintOfficeMode() ? !checkButtonRadio : !agreeIneCheckbox}
            >
                {this.buildINE()}
            </WizardStep>,
            ...commonSteps.slice(4)
        ] : commonSteps;

        return (
            <div>
                <div className="col-xs-12 col-md-8">
                    <Wizard
                        actions={wizardActions}
                        immSteps={immSteps}
                        showPreLeaveModal={showPreLeaveModal}
                        stepsAmount={immSteps.size}
                        tealium={tealiumData[visibleStep - 1]}
                        visibleStep={visibleStep}
                        wizardClass="hire-card-diamond-pack__wizard"
                        isTaggingSecondVersion
                    >
                        {newSteps}
                    </Wizard>

                </div>
                <div className="col-xs-12 col-md-4">
                    <div className="row">
                        <div className="col-xs-6 col-md-12 grid-view--variable-cell-separation">
                            <HireCardSidebar
                                collectiveEnabled={isCollectiveEnabledForDiamondPack}
                                creditType="diamond"
                                collectiveTagData={collectiveTagData}
                                extraImage={EXTRA_IMAGE}
                                immAccounts={immAccounts}
                                immGlobalVariables={immGlobalVariables}
                                immHireCardImageSelector={immHireCardImageSelector}
                                immHireCardNameSelector={immHireCardNameSelector}
                                immHireCreditLimit={immHireCreditLimit}
                                immHirePaymentMethod={immHirePaymentMethod}
                                immAddress={immShippingAddress}
                                immShippingAddressList={immShippingAddressList}
                                immProfile={immProfile}
                                selectedAccount={immSteps.getIn([THIRD_STEP, 'accountId'])}
                                hasShippingAddress={hasShippingAddress}
                            />
                        </div>
                        <div className="col-xs-6 col-md-12 grid-view--fix-cell-separation">
                            <CallMeBack context="contracts" modifier="contracts-view" pageTitle={formatText('breadcrumb-cards')} hasEntrance={false} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const {
            immHireCardDiamondPack,
            immAccounts,
            immCards,
            immFlagBasedFeatures,
            immProfile,
        } = this.props;
        const pageTitle = getFinalTitle('hireCardDiamondPack-pageTitle');
        let hasAvailableAccounts = true;
        if (__CONTACT_CENTER__) {
            hasAvailableAccounts = ownerFromAccount(immAccounts);
        }

        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-cards'),
                url: '/myprofile/cards'
            },
            {
                text: formatText("hireCardDiamondPack-breadcrumb")
            }
        ];
        let content;

        const hasAvailableCreditCards = isAvailableHireCreditCards(immCards);
        const isSecondStep = immHireCardDiamondPack.get('visibleStep') == WIZARD_SECOND_STEP;
        const isNerudaUser = immProfile.get('isNerudaUser');
        const creditCardsLimitExceed = immFlagBasedFeatures.get(LIMIT_CREDIT_CARD) && !isNerudaUser && !hasAvailableCreditCards && isSecondStep;
        const processDetail = this.getProcessDetail();
        const hireRestrictionFlag = immHireCardDiamondPack.getIn(['steps', WIZARD_FIRST_STEP - 1, 'hireRestriction']);
        const hireRestrictionFF = immFlagBasedFeatures.get(MESSAGE_HIRE_24H);
        if (immHireCardDiamondPack.get('error')
            || (__CONTACT_CENTER__ && !hasAvailableAccounts)
            || creditCardsLimitExceed) {
            content = (
                <div className="col-xs-12 col-md-offset-1 col-md-10">
                    <HireCarDiamondPackError
                        immHireCardDiamondPack={immHireCardDiamondPack}
                        hasAvailableAccounts={__CONTACT_CENTER__ ? hasAvailableAccounts : undefined}
                        processDetail={processDetail}
                        maxAllowedNumberCards={creditCardsLimitExceed}
                    />
                </div>
            );
        } else if (hireRestrictionFlag && hireRestrictionFF) {
            content = (
                <div className="col-xs-12 col-md-offset-1 col-md-10">
                    <HireCarDiamondPackError
                        immHireCardDiamondPack={immHireCardDiamondPack}
                        hasAvailableAccounts={__CONTACT_CENTER__ ? hasAvailableAccounts : undefined}
                        processDetail={processDetail}
                        maxAllowedNumberCards={creditCardsLimitExceed}
                        hireRestrictionFlag={hireRestrictionFlag}
                    />
                </div>
            );
        } else if (immHireCardDiamondPack.get('submitSuccessful')) {
            content = this.buildSuccessful();
        } else {
            content = this.buildWizardHiringSteps();
        }

        return (
            <div className="hire-card-diamond-pack">
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="pg" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={mappingBreadcrumb}
                                finalTitle={pageTitle}
                            />
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            {content}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

HireCardDiamondPackView.propTypes = {
    gestorCrossEnabled: PropTypes.bool,
    getshippingAddressList: PropTypes.func,
    getBlockedAccounts: PropTypes.func,
    handleAccountChange: PropTypes.func.isRequired,
    handleAgreementCheckboxChange: PropTypes.func.isRequired,
    hireCardDiamondPack: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    immCollectivesCardContent: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immGlobalVariables: PropTypes.object.isRequired,
    immHireCardImageSelector: PropTypes.object.isRequired,
    immHireCardNameSelector: PropTypes.object.isRequired,
    immHireCardDiamondPack: PropTypes.object.isRequired,
    immHireContactData: PropTypes.object.isRequired,
    immHireCreditLimit: PropTypes.object.isRequired,
    immHireInformation: PropTypes.object.isRequired,
    immHirePaymentMethod: PropTypes.object.isRequired,
    immHiringProductBanners: PropTypes.object,
    immPdfData: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    immShippingAddressList: PropTypes.object,
    immTopbar: PropTypes.object,
    isCollectiveEnabled: PropTypes.bool,
    match: PropTypes.object,
    requestPDFMerge: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    resetBlockedAccounts: PropTypes.func,
    resetTermsAndCondsText: PropTypes.func.isRequired,
    resetPrecontractualDocumentMail: PropTypes.func,
    resetPrecontractualMail: PropTypes.func.isRequired,
    sendPrecontractualDocumentMail: PropTypes.func.isRequired,
    setAllAccountsToInactive: PropTypes.func.isRequired,
    setHireCreditLimit: PropTypes.func.isRequired,
    setShippingAddress: PropTypes.func,
    setTermsAndCondsText: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    toggleCreditLimitModal: PropTypes.func.isRequired,
    validate: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    immRevolvingPersistentData: PropTypes.object,
};

module.exports.constructor = HireCardDiamondPackView;
module.exports.HireCardDiamondPackView = connect(
    state => ({
        gestorCrossEnabled: state.flagBasedFeatures.get('web-gc-enabled'),
        isCollectiveEnabled: state.flagBasedFeatures.get('collectivos-enabled'),
        immAccounts: state.accounts,
        immCards: state.cards,
        immCollectivesCardContent: state.collectivesCardContent,
        immFlagBasedFeatures: state.flagBasedFeatures,
        immGlobalVariables: state.globalVariables,
        immHireCardImageSelector: state.hireCardImageSelector,
        immHireCardNameSelector: state.hireCardNameSelector,
        immHireCardDiamondPack: state.hireCardDiamondPack,
        immHireContactData: state.hireContactData,
        immHireCreditLimit: state.hireCreditLimit,
        immHireInformation: state.hireInformation,
        immHirePaymentMethod: state.hirePaymentMethod,
        immHiringProductBanners: state.hiringProductBanners,
        immPdfData: state.precontractualsMergePdfs,
        immProfile: state.profile,
        immShippingAddressList: state.shippingAddress,
        immTopbar: state.topbar,
        immRevolvingPersistentData: state.revolvingPersistentData,
        immPrinter: state.printer,
    }),
    {
        getBlockedAccounts: blockedAccountsAction.getBlockedAccounts,
        getshippingAddressList: shippingAddressAction.getShippingAddressList,
        handleAccountChange: hireCardDiamondPackActions.setAccount,
        handleAgreementCheckboxChange: hireCardDiamondPackActions.setAgreementCheckbox,
        onHandleChangeCheckBoxCC: hireCardDiamondPackActions.onHandleChangeCheckBoxCC,
        hireCardDiamondPack: hireCardDiamondPackActions.hireCardDiamondPack,
        requestPDFMerge: mergePreContractualsPDF.requestPDFMerge,
        reset: hireCardDiamondPackActions.reset,
        resetBlockedAccounts: blockedAccountsAction.resetBlockedAccounts,
        resetPrecontractualDocumentMail: precontractualDocumentMailAction.resetPrecontractualDocumentMail,
        resetPrecontractualMail: preContractualMailActions.resetPrecontractualMail,
        sendPrecontractualDocumentMail: precontractualDocumentMailAction.sendPrecontractualDocumentMail,
        resetTermsAndCondsText: termsAndCondsInfoActions.reset,
        setAllAccountsToInactive: hireCardDiamondPackActions.setAllAccountsToInactive,
        setHireCreditLimit: hireCreditLimitActions.setHireCreditLimit,
        setShippingAddress: shippingAddressAction.setShippingAddress,
        setTermsAndCondsText: termsAndCondsInfoActions.setTermsAndCondsText,
        setVisibleStep: hireCardDiamondPackActions.setVisibleStep,
        setWillCancel: hireCardDiamondPackActions.setWillCancel,
        toggleCreditLimitModal: hireCreditLimitActions.toggleModal,
        validate: hireCardDiamondPackActions.validate,
        validateStep: hireCardDiamondPackActions.validateStep,
        cardsConfimationScrollDown: hireCardCreditINEActions.cardsConfimationScrollDown,
        cardsConfimationScrollDownPolicy: hireCardCreditINEActions.cardsConfimationScrollDownPolicy,
        checkCheckedDocument: hireCardCreditINEActions.checkCheckedDocument,
        printedAndSignedRadioChanged: printedActions.printedAndSignedRadioChanged,
        enableButtonOffice: mortgageRequestHolderConfirmation.enableButtonOffice,
        checkRadioButton: hireCardDiamondPackActions.checkRadioButton,
        checkRadioButtonPolicy: hireCardDiamondPackActions.checkRadioButtonPolicy,
        hireCardDiamondPackPrintDocument: hireCardDiamondPackActions.printDocument,
        hireCardDiamondPackPrintDocumentPolicy: hireCardDiamondPackActions.printDocumentPolicy,
        myCardsTarjetasHire: hireCardDiamondPackActions.myCardsTarjetasHire,
        processEmail: hireCardDiamondPackActions.processEmail,
        getInitCardsDocuments: hireCardCreditINEActions.getInitCardsDocuments,
    }
)(withRouter(HireCardDiamondPackView));
